import ScreenshotOverlay from "@/components/maps/ScreenshotOverlay"
import { Route2g } from "@/reducers/routes2gSlice"
import { useShareRoute } from "@/hooks/useShareRoute"
import { Button } from "../ui/button"
import { Share } from "lucide-react"
import { useTranslation } from "react-i18next"

const ShareRoute = ({
  route,
  driverJid,
}: {
  route: Route2g
  driverJid: string
  isLoading?: boolean
}) => {
  const { t } = useTranslation()
  const { share, sharing, isDoubleCrew } = useShareRoute(route, driverJid)

  return (
    <div className="absolute bottom-2 right-2 mr-8">
      <Button
        id="share-route"
        variant="outline"
        size="sm"
        onClick={share}
        disabled={sharing}
        className="rounded-md text-xs dark:bg-gray-700 dark:text-white"
        title={t("maps.shareRoute.title")}
      >
        {isDoubleCrew
          ? t("maps.shareRoute.sendToDrivers")
          : t("maps.shareRoute.sendToDriver")}
        <Share />
      </Button>
      {sharing && <ScreenshotOverlay isVisible={sharing} />}
    </div>
  )
}

export default ShareRoute
